
import {Component} from '@angular/core';
import {CardModule} from 'primeng/card';

@Component({
  selector: 'app-service-card',
  imports: [CardModule],
  templateUrl: './service-card.component.html',
})
export class ServiceCardComponent {}
